import React from 'react'

// Multi-select list of reasons for exchange (SRS 1.1 / 1.3).
// VS[0] is an array of the selected option strings.
export default function MultiSelectInput({label, options, VS, setVS}) {

    function toggleOption(option){
        let selected = VS[0].slice();
        if(selected.includes(option)){
            selected = selected.filter((o) => o !== option);
        }else{
            selected.push(option);
        }
        setVS([selected, (selected.length > 0)? 1 : -1]);
    }

    return (
        <div className='iolx-multiselect'>
            <span className='controlLabel iolx-label'
            style={{display: (label === '')? 'none' : null}}>{label}</span>
            <div className='iolx-multiselect-options'>
                {options.map((option) =>
                    <span key={option}
                    className={'iolx-chip' + ((VS[0].includes(option))? ' selected' : '')}
                    onClick={() => toggleOption(option)}>
                        {option}
                    </span>
                )}
            </div>
        </div>
    )
}
